import React, { useState, useEffect } from 'react'
import Loading from '../general/Loading';
import Logo from '../assets/logo.png';

const PaymentHistory = ({ userData }) => {
    const [payData, setPayData] = useState([]);
    const [selectedItem, setSelectedItem] = useState();
    const [showView, setShowView] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');


    useEffect(() => {
        const fetchPayments = async () => {
            setLoading(true);
            try {
                const response = await fetch(`https://api.kcmstore.in/dist/get-payment-history`);
                setLoading(false);

                if (response.ok) {
                    const data = await response.json();
                    const sortedProducts = data.sort((a, b) => b.id - a.id);
                    setPayData(sortedProducts);
                } else {
                    setLoading(false);
                    console.error('Failed to fetch products');
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching products:', error);
            }
        };

        fetchPayments();
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    };

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('en-GB', { 
            day: '2-digit', 
            month: 'short', 
            year: 'numeric',
            hour: '2-digit', 
            minute: '2-digit', 
            hour12: true 
        }).replace(',', '');
    };
    

    const showViewDialog = (paymentData) => {
        setShowView(true);
        setSelectedItem(paymentData);
    }

    const handlePrint = () => {
        window.print();
    }

    const filteredPayment = payData.filter(paymentData => {
        const isDateMatch = formatDate(paymentData.order_date).toLowerCase().includes(searchQuery.toLowerCase());
        const isUserMatch = paymentData.customer_name.toLowerCase().includes(searchQuery.toLowerCase());
        const isIdMatch = paymentData.order_id && paymentData.order_id.toString().toLowerCase().includes(searchQuery.toLowerCase());
        return isDateMatch || isUserMatch || isIdMatch;
    });


    return (
        <>
            <section className='px-md-3 px-sm-3 py-3'>
                <div className='profile-area-inner px-lg-4 py-lg-4 px-3 py-3 animate__animated animate__fadeInUp'>
                    <p className='profile-heading'>Payment History</p>
                    {/* <hr className='profile-hr my-0' /> */}

                    <div className="text-start mb-4">
                        <input
                            type="text"
                            className="profile-input rounded border-0 bg-light"
                            placeholder="Search Here..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>


                    {filteredPayment.length > 0 ? (
            filteredPayment.map((paymentData) => (
              <div className='due-area my-2'>
                <div className='d-flex justify-content-between'>
                  <span><span className='fw-semibold'>{paymentData.customer_name}</span><br /><br />
                    Invoice No: {paymentData.id}<br />Order Date: {formatDate(paymentData.order_date)}<br />
                    Total Amount: ₹{Number(paymentData.total_amount).toFixed(2)}<br />
                    <span className='fw-semibold text-success'>Amount Received: ₹{Number(paymentData.amount_received).toFixed(2)}</span>
                  </span>

<div>
                  <p className='due-tag cursor-pointer' onClick={() => showViewDialog(paymentData)}>View</p></div>
                </div>


              </div>
            ))
          ) : (
            <p className='fw-semibold my-3'>No Payments made yet.</p>
          )}

                </div>
            </section>


            {showView && (
                <>
                    <section className='detail-dialog' onClick={() => setShowView(false)}>
                        <div className='invoice-dialog-inner animate__animated animate__zoomIn col-lg-8 mx-auto px-lg-5 py-lg-5 px-3 py-3' onClick={(e) => e.stopPropagation()}>

                        <p className='profile-subheading text-center'>Order Invoice</p>
                        <img src={Logo} className='invoice-watermark' alt='WaterMark' />

                        <div className='invoice-area'>


<p className='fw-semibold my-0'>Sold By: {userData.name}</p>
    <p className='para-text fst-italic my-0'><span className='fw-semibold'>Billing Address:</span> {userData.address} {userData.city} {userData.state} {userData.pincode}</p>
    <p><span className='fw-semibold'>GSTIN: </span>{userData.gst || 'NA'}</p>


<div className='text-end'>
<span className='invoice-num fw-semibold'>Invoice Number {selectedItem.id || 'NA'}</span></div>

<hr />

<div className='d-flex pt-2'>
  <div>
<p className='fw-semibold my-0'>Order Id: {selectedItem.id}</p>
<p><span className='fw-semibold'>Order Date: </span>{formatDateTime(selectedItem.order_date)}</p></div>

<p className='ms-4'><span className='fw-semibold'>Delivery Address</span><br />
{selectedItem.customer_address} {selectedItem.customer_city} {selectedItem.customer_state} {selectedItem.customer_pincode}</p>

</div>
{/* flex ends */}

<hr />


<div className='table-responsive'>
                  <table className='w-100'>
                    <tr>
                    <th className='fw-semibold px-2'>Product</th>
                    <th className='fw-semibold px-2'>Qty</th>
                    <th className='fw-semibold px-2'>MRP</th>
                      <th className='fw-semibold px-2'>Discount</th>
                      <th className='fw-semibold px-2'>Tax</th>
                      <th className='fw-semibold px-2'>Sale Price</th>
                      <th className='fw-semibold px-2'>Total</th>
                    </tr>

                    {typeof selectedItem.order_items === 'string' ? (
                      (() => {
                        try {
                          const parsedItems = JSON.parse(selectedItem.order_items);
                          if (Array.isArray(parsedItems)) {
                            return parsedItems.map((item, index) => (
                              <tr key={index}>
                                <td className='px-2 py-2 fw-semibold'>{item.product_name}</td>
                                <td className='px-2 py-2 fw-semibold'>{item.quantity}</td>
                                <td className='px-2 py-2 fw-semibold'>₹{item.product_org}</td>
                                <td className='px-2 py-2 fw-semibold'>{item.product_discount_type == 'amount' ? '₹' : ''}{item.product_discount_amount || 'NA'}{item.product_discount_type == 'percent' ? '%' : ''}</td>
                                <td className='px-2 py-2 fw-semibold'>
  {item.product_tax && item.product_tax.toLowerCase() !== 'none' ? 
    (() => {
      const match = item.product_tax.match(/([\d.]+)/); // Extracts numeric value including decimals
      const taxValue = match ? parseFloat(match[0]) : null; // Convert extracted value to number

      if (!isNaN(taxValue) && taxValue > 0) {
        if (taxValue === 0.25 || taxValue === 0) { 
          return `GST ${taxValue}%`;
        } 
        const halfTax = (taxValue / 2).toFixed(2);
        return `CGST ${halfTax}% SGST ${halfTax}%`;
      }
      return item.product_tax; // In case of unexpected format
    })()
    : 'none'}
</td>

                                <td className='px-2 py-2 fw-semibold'>₹{item.product_sp}</td>
                                <td className='px-2 py-2 fw-semibold'>₹{(item.product_sp * item.quantity).toFixed(2)}</td>
                                </tr>
                            ));
                          }
                        } catch (error) {
                          return <p>Failed to get items.</p>
                        }
                      })()
                    ) : (
                      <p>No items available.</p>
                    )}

                  </table>
                </div>

<hr />


<p className='para-text fw-semibold text-end'>Grand Total ₹{Number(selectedItem.total_amount).toFixed(2)}<br />
<span className='text-success'>Amount Paid: ₹{Number(selectedItem.amount_received).toFixed(2)}</span><br />
<span className='text-danger'>Due Amount: ₹{Number(selectedItem.due_amount).toFixed(2)}</span></p>

<p className='para-text text-center mt-4 fw-semibold'>Thanks for choosing KCM Distributors as your Medicine Supplier.</p>


</div>
{/* invoice ends */}

                            {/* <div className='invoice-area'>
                                <div className='d-flex justify-content-between'>
                                    <p>Sold By: KCM Store<br />GSTIN: {userData.gst}<br />Invoice No: {selectedItem.id}</p>
                                    <p>Order Id: {selectedItem.order_id}<br />Order Date: {formatDate(selectedItem.order_date)}<br />Billing Address: {selectedItem.customer_name}<br />
                                        {selectedItem.customer_address} {selectedItem.customer_city} {selectedItem.customer_state}</p>
                                </div>
                                <hr />

                                <div className='table-responsive'>
                                    <table className='w-100'>
                                        <tr>
                                            <th>Product</th>
                                            <th>List Price</th>
                                            <th>Discount</th>
                                            <th>Tax Value</th>
                                            <th>Sell Price</th>
                                            <th>Qty</th>
                                            <th>Total</th>
                                        </tr>

                                        {typeof selectedItem.order_items === 'string' ? (
                                            (() => {
                                                try {
                                                    const parsedItems = JSON.parse(selectedItem.order_items);
                                                    if (Array.isArray(parsedItems)) {
                                                        return parsedItems.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.product_name}</td>
                                                                <td className='px-2 py-2'>{item.product_org}</td>
                                                                <td>{item.product_discount_type == 'amount' ? '₹' : ''} {item.product_discount_amount} {item.product_discount_type == 'percent' ? '%' : ''}</td>
                                                                <td>{item.product_tax || 'none'}</td>
                                                                <td className='px-2 py-2'>₹{item.product_sp}</td>
                                                                <td>{item.quantity}</td>
                                                                <td>₹{item.product_sp * item.quantity}</td>
                                                            </tr>
                                                        ));
                                                    }
                                                } catch (error) {
                                                    return <p>Failed to get items.</p>
                                                }
                                            })()
                                        ) : (
                                            <p>No items available.</p>
                                        )}

                                    </table>
                                </div>

                                <hr />

                                <p>Grand Total {selectedItem.total_amount}<br />Amount Paid: {selectedItem.amount_received} <br />Due Amount: {selectedItem.due_amount}</p>

                                <p className='para-text text-center mb-0 mt-4'>Thanks for choosing KCM Distributors as your Medicine Supplier.</p>

                            </div> */}
                            {/* invoice ends */}
                            <button className='login-btn mt-4 bg-danger' onClick={() => setShowView(false)}>Close</button>&nbsp;&nbsp;
                            <button className='login-btn mt-4' onClick={handlePrint}>Download</button>


                        </div>
                    </section>
                </>
            )}

{loading && <Loading setLoading={setLoading} />}

        </>
    )
}

export default PaymentHistory
